import { gql } from "@apollo/client";

export const SERVICES = gql`
  query queryServices($franchise_id: Float, $acting_region_id: Float, $acting_region_name: String) {
    services(franchise_id: $franchise_id, acting_region_id: $acting_region_id, acting_region_name: $acting_region_name) {
      id
      name
      description
      icon_path
      image_path
      capacity
      base_rate
      gender
      minimum_price
      price_per_stop
      price_per_people
      cost_per_minute
      cost_per_km
      booking_fee
      rush_hour
      is_actived
      is_deleted
      boarding_waiting_time_in_seconds
      max_meters_request_drivers
      max_meters_next_race
      max_meters_diff
      max_time_diff
      max_search_booking_in_seconds
      fee
      fee_fix
      order
      send_notification
      currency
      single_race
      is_negotiable
      is_schedulable
      is_callcenter
      is_service
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
      category {
        id
        name
      }
      # created_at
      # updated_at
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export const AVAILABLE_SERVICES = gql`
  query queryServices($driver_id: Float, $franchise_id: Float, $acting_region_id: Float, $not_negotiable: Boolean, $is_callcenter: Boolean) {
    services(driver_id: $driver_id, franchise_id: $franchise_id, acting_region_id: $acting_region_id, not_negotiable: $not_negotiable, is_callcenter: $is_callcenter) {
      id
      name
      description
      icon_path
      image_path
      capacity
      base_rate
      gender
      minimum_price
      cost_per_minute
      cost_per_km
      booking_fee
      rush_hour
      is_negotiable
      is_schedulable
      is_service
      is_actived
      is_deleted
      is_selected
      # created_at
      # updated_at
    }
  }
`;

export const SERVICE_PRICE = gql`
query availableServices($data: stopInput!) {
  availableServices(
    data: $data
  ) {
    id
    name
    description
    icon_path
    image_path
    capacity
    base_rate
    minimum_price
    cost_per_minute
    cost_per_km
    booking_fee
    price
    routeTime
    distance
  }
}
`;

export default SERVICES;
